export default "__VITE_ASSET__BP$m3Ln$__"